<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="modal fade" id="costumModaldisclaimer" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Penjelasan dan Ketentuan</h4>
                </div>
                <div class="modal-body text-justify">
                    <p style="font-size: smaller;">
                        <b>SIMFAST JATENG</b> (Sistem Manajemen Infrastruktur Terpadu Jawa Tengah)
                        yang selanjutnya dioptimalkan sebagai "<b>Strategi Mensinergikan Fokus dan Arah Kebijakan
                        Perencanaan Berbasis Data Spasial Terpadu di Jawa Tengah</b>" merupakan sistem manajemen (alat
                        kerja) yang mengintegrasikan analisa data dan informasi infrastruktur (terkait Urusan PUPR,
                        Perhubungan, Prakim, LHK, ESDM, Kominfo) secara terpadu dengan sektor lain (ekonomi dan sosial)
                        untuk menghasilkan prioritas rencana penanganan infrastruktur di Jawa Tengah yang paling efektif
                        dan efisien dalam mewujudkan tujuan pembangunan di Provinsi Jawa Tengah.
                    </p>
                    <p class="text-center">
                    <div class="row">
                        <div class="col-sm-12 float-left">
                            <label style="font-size: smaller;" class="text-success">Silahkan Mengisi Daftar
                                Pengunjung</label>
                        </div>
                        <div class="col-sm-12 float-left">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="far fa-address-card"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="nama" name="nama"
                                    placeholder="Nama" v-model="nama">
                            </div>
                        </div>
                        <div class="col-sm-12 float-left">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-phone-square"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="hp" name="hp"
                                    placeholder="Nomor Telepon" v-model="hp" @keypress="onlyNumberKey(event)"
                                    @keydown="onlyNumberKey(event)">
                            </div>
                        </div>
                        <div class="col-sm-12 float-left">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-clipboard-list"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="keperluan" name="keperluan"
                                    placeholder="Keperluan" v-model="keperluan">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left">
                            <label style="font-size: smaller;" class="text-success">Kode Keamanan</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-key"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="capcha" name="capcha"
                                    placeholder="Kode Keamanan" v-model="capcha" disabled @click.right.prevent
                                    @keydown="keydown" @copy.prevent @paste.prevent>
                            </div>
                        </div>
                        <div class="col-sm-6 float-left">
                            <label style="font-size: smaller;" class="text-success">Ulangi Kode Keamanan</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="far fa-clone"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="capchainput"
                                    name="capchainput" v-model="capchainput" style="text-transform:uppercase"
                                    @click.right.prevent @keydown="keydown" @copy.prevent @paste.prevent>
                            </div>
                        </div>
                    </div>
                    <input type="checkbox" id="customSwitchAuth" @click="rubahisi()">
                    <label style="font-size: small;" for="customSwitchAuth">
                        &nbsp;Saya mengerti dan menyetujui penjelasan dan ketentuan diatas.
                    </label>
                    </p>
                </div>
                <div class="modal-footer justify-content-between">
                    <button class="btn btn-danger2 btn-block text-white" placeholder="Setuju dan lanjutkan"
                        data-toggle="tooltip" data-placement="left" title="Setuju dan lanjutkan.." style="color: black;"
                        :disabled="showHuman == false" @click="setuju()">
                        <b>
                            Setuju dan lanjutkan
                        </b>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid bg-breadcrumb">
        <div class="container text-center py-5" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInUp pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">RIWAYAT PENANGANAN INFRASTRUKTUR</span>
                <span v-else>RIWAYAT PENANGANAN INFRASTRUKTUR</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInUp" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-primary">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Riwayat Penanganan Infrastruktur Provinsi Jawa
                        Tengah</span>
                    <span v-else>Riwayat Penanganan Infrastruktur Provinsi Jawa Tengah</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <div class="container-fluid py-4 wow fadeInUp" data-wow-delay="0.1s">
        <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
            style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
            <div class="sub-style">
                <h4 class="sub-title px-3 mb-0 labelpmis">
                    DAFTAR RIWAYAT PENANGANAN INFRASTRUKTUR BANTUAN KEUANGAN KEPADA KABUPATEN / KOTA PROVINSI JAWA
                    TENGAH
                </h4>
            </div>
        </div>
        <div class="container">
            <div class="col-sm-12 wow fadeInUp">
                <div class="card cardputih collapsed-card">
                    <div class="card-header border-transparent" data-card-widget="collapse" style="cursor: pointer;">
                        <label>
                            <span>Filter Data</span>
                        </label>
                        <div class="card-tools">
                            <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                <i class="fas fa-plus"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body px-3">
                        <div class="row">
                            <div class="col-sm-3">
                                <label>Tahun</label>
                                <v-select :options="tahun" :reduce="(label) => label.code" label="label"
                                    v-model="defaultSelectedtahun" @update:modelValue="ontahunChange"
                                    style="background-color: #ffffff;"></v-select>
                            </div>
                            <div class="col-sm-3">
                                <label>Anggaran</label>
                                <v-select :options="anggaran" :reduce="(label) => label.code" label="label"
                                    v-model="defaultSelectedanggaran" @update:modelValue="onanggaranChange"
                                    style="background-color: #ffffff;"></v-select>
                            </div>
                            <div class="col-sm-6">
                                <label>Kabupaten / Kota</label>
                                <v-select :options="kabkot" :reduce="(label) => label.code" label="label"
                                    v-model="defaultSelectedkabkot" @update:modelValue="onkabkotChange"
                                    style="background-color: #ffffff;"></v-select>
                            </div>
                            <div class="col-sm-12">&nbsp;</div>
                            <div class="col-sm-12">
                                <label>Jenis Bantuan Keuangan</label>
                                <v-select :options="jenisbantuan" :reduce="(label) => label.code" label="label"
                                    v-model="defaultSelectedjenisbantuan" @update:modelValue="onjenisbantuanChange"
                                    style="background-color: #ffffff;"></v-select>
                            </div>
                            <div class="col-sm-12">&nbsp;</div>
                            <div class="col-sm-12">
                                <label>Bidang Bantuan Keuangan</label>
                                <v-select :options="bidangbantuan" :reduce="(label) => label.code" label="label"
                                    v-model="defaultSelectedbidangbantuan" @update:modelValue="onbidangbantuanChange"
                                    style="background-color: #ffffff;"></v-select>
                            </div>
                            <div class="col-sm-12">&nbsp;</div>
                            <div class="col-sm-12">
                                <label>Sub Bidang Bantuan Keuangan</label>
                                <v-select :options="subbidangbantuan" :reduce="(label) => label.code" label="label"
                                    v-model="defaultSelectedsubbidangbantuan"
                                    @update:modelValue="onsubbidangbantuanChange"
                                    style="background-color: #ffffff;"></v-select>
                            </div>
                            <div class="col-sm-12">&nbsp;</div>
                            <div class="col-sm-12 text-center">
                                <button type="button" class="btn btn-success3 btn-sm text-white lebar2"
                                    @click="ambildata()" data-toggle="tooltip" data-placement="left"
                                    title="Terapkan Filter..">
                                    <i class="fas fa-search"></i> Terapkan Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container py-2">
            <div class="col-sm-12 text-center py-2">
                <a class="hitam">
                    <button type="button" class="btn btn-success btn-sm text-white lebar2" data-toggle="tooltip"
                        data-placement="left" title="Unduh excel.."
                        @click="G_tableCSVTabel2('_DaftarRiwayatPenangananRekapKota_')">
                        <i class="fas fa-download"></i>
                        <span>
                            Unduh Data .xlsx
                        </span>
                    </button>
                </a>
            </div>
            <div class="col-sm-12 wow fadeInUp">
                <div class="table-responsive table-wrapper">
                    <table class="table m-0" id="tabeldata" style="font-size: small;">
                        <thead>
                            <tr>
                                <th style="width: 50px;">No</th>
                                <th style="width: 150px;">Kabupaten / Kota</th>
                                <th style="width: 50px;">Jumlah Kegiatan</th>
                                <th style="width: 80px;">Jumlah Alokasi Anggaran (Rp.)</th>
                                <th style="width: 250px;">Sumber Data</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="total" colspan="2">TOTAL</td>
                                <td class="total text-center" data-z="#,##0" :data-v="totalkegiatan">{{ G_numFormat(totalkegiatan) }}</td>
                                <td class="totalkanan" data-z="#,##0.00" :data-v="totalalokasi">{{ G_numFormatKoma(totalalokasi) }}</td>
                                <td class="total"></td>
                            </tr>
                            <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                                <tr>
                                    <td class="text-center">
                                        {{ (urutlist + 1) }}
                                    </td>
                                    <td class="text-justify">
                                        {{ datalist.NAMAKABKOT }}
                                    </td>
                                    <td class="text-center" data-z="#,##0" :data-v="datalist.JumlahKegiatan">
                                        {{ G_numFormat(datalist.JumlahKegiatan) }}
                                    </td>
                                    <td class="text-right" data-z="#,##0.00" :data-v="datalist.JumlahBantuan">
                                        {{ G_numFormatKoma(datalist.JumlahBantuan) }}
                                    </td>
                                    <td class="text-justify">
                                        {{ datalist.SumberData }}
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import { ref } from 'vue'
import treeview from "vue3-treeview";
import "vue3-treeview/dist/style.css";
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import xlsx from 'xlsx/dist/xlsx.full.min';
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";
import vSelect from 'vue-select';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-Regular, Arial, sans-serif" };

export default {
    components: {
        Top, Footer, swal, tree: treeview, vSelect
    },
    data() {
        return {
            halamanloading: true,
            showHuman: false,
            tampilmodal: localStorage.getItem("bookstamu"),
            capcha: this.makeid(5), capchainput: "",
            nama: '',
            hp: '',
            keperluan: '',
            ipnya: '',
            datapesan: '',
            datamaster: [],
            tahun: [],
            datatahun: [],
            defaultSelectedtahun: {
                code: 0,
                label: 'Semua Tahun',
                tag: '',
            },
            selectedtahun: '',
            kabkot: [],
            datakabkot: [],
            defaultSelectedkabkot: {
                code: 0,
                label: 'Semua Kabupaten/Kota',
                tag: '',
            },
            selectedkabkot: '',
            jenisbantuan: [],
            datajenisbantuan: [],
            defaultSelectedjenisbantuan: {
                code: 0,
                label: 'Semua Bantuan Keuangan',
                tag: '',
            },
            selectedjenisbantuan: '',

            bidangbantuan: [],
            databidangbantuan: [],
            defaultSelectedbidangbantuan: {
                code: 0,
                label: 'Semua Bidang Bantuan Keuangan',
                tag: '',
            },
            selectedbidangbantuan: '',

            subbidangbantuan: [],
            datasubbidangbantuan: [],
            defaultSelectedsubbidangbantuan: {
                code: 0,
                label: 'Semua Sub Bidang Bantuan Keuangan',
                tag: '',
            },
            selectedsubbidangbantuan: '',
            anggaran: [],
            dataanggaran: [],
            defaultSelectedanggaran: {
                code: 0,
                label: 'Semua Anggaran',
                tag: '',
            },
            selectedanggaran: '',
            totalkegiatan: 0,
            totalalokasi: 0,
        };
    },
    methods: {
        async G_tableCSVTabel2(namefile) {
            this.halamanloading = true;
            const XLSX = xlsx;
            var wb = XLSX.utils.table_to_book(document.getElementById('tabeldata'), { sheet: "DaftarRiwayatPenanganan" });
            XLSX.writeFile(wb, this.G_formatDate(Date(), 'd-M-Y') + namefile + ".xlsx");
            this.halamanloading = false;
        },
        onlyNumberKey(evt) {
            // Only ASCII character in that range allowed
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            } return;
        },
        rubahisi() {
            if ((this.showHuman == false) && (this.capcha == this.capchainput.toUpperCase())) {
                if (this.nama.length <= 2) {
                    this.showHuman = false;
                    document.getElementById("customSwitchAuth").checked = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan nama dengan benar',
                    });
                    return false;
                }
                if ((this.hp.length <= 4) || (typeof parseInt(this.hp) != "number")) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan nomor telp dengan benar',
                    });
                    return false;
                }
                if (this.keperluan.length <= 3) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan keperluan dengan benar',
                    });
                    return false;
                }
                this.showHuman = true;
            }
            else {
                if (this.capcha != this.capchainput.toUpperCase()) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Kode keamanan tidak sama',
                    });
                }
                this.showHuman = false;
            }
        },
        async setuju() {
            this.halamanloading = true;

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });

            this.halamanloading = true;
            const data = {
                tamuparastapa: 'tamuparastapa',
                nama: this.nama,
                hp: this.hp,
                keperluan: this.keperluan,
            };
            const mainAPIVisitor = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            await mainAPIVisitor.post("parastapainnovatioBukuTamu-IsiTamu", data).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: Response.data.message,
                        });
                        this.halamanloading = false;
                        return false;
                    }
                    else {
                        localStorage.setItem("bookstamu", new Date().toString());
                        $('#costumModaldisclaimer').modal('hide');
                        this.halamanloading = false;
                        //window.location.reload();
                    }
                }
            ).catch(
                error => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: error,
                    });
                }
            )

        },
        async cekdisklaimer() {
            if ((this.tampilmodal == null) || (this.tampilmodal == '') || (this.tampilmodal == undefined)) {
                $('#costumModaldisclaimer').modal('show');
            }

            var time = Date.parse(localStorage.getItem("bookstamu"));
            var timeakhir = time + (1 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                $('#costumModaldisclaimer').modal('show');
            }
        },
        async ambildatareff() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });
            this.halamanloading = true;
            const mainAPI2 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                },
            });
            var random = Math.random();
            await mainAPI2.get("parastapainnovationreff-GetKabkot?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datakabkot = [];
                        this.kabkot = [];
                        this.datakabkot = Response.data.content.data;
                        this.datakabkot.forEach((item) => {
                            this.kabkot.push({
                                label: item.NAMA,
                                code: this.datakabkot.indexOf(item) + 1,
                                tag: item.KD_KAB,
                            });
                        });
                        this.kabkot.unshift({
                            label: 'Semua Kabupaten/Kota',
                            code: 0,
                            tag: '',
                        });
                    }
                    else {
                        this.datakabkot = [];
                        this.kabkot = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.datakabkot = [];
                this.kabkot = [];
                //console.log(error);
                this.halamanloading = false;
            });
            this.halamanloading = true;
            await mainAPI2.get("parastapainnovationreff-GetTahunRiwayatPenanganan?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datatahun = [];
                        this.tahun = [];
                        this.datatahun = Response.data.content.data;
                        this.datatahun.forEach((item) => {
                            this.tahun.push({
                                label: item.tahun,
                                code: this.datatahun.indexOf(item) + 1,
                                tag: item.tahun,
                            });
                        });
                        this.tahun.unshift({
                            label: 'Semua Tahun',
                            code: 0,
                            tag: '',
                        });
                    }
                    else {
                        this.datatahun = [];
                        this.tahun = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.datatahun = [];
                this.tahun = [];
                //console.log(error);
                this.halamanloading = false;
            });
            this.halamanloading = true;
            await mainAPI2.get("parastapainnovationreff-GetJenisBantuan?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datajenisbantuan = [];
                        this.jenisbantuan = [];
                        this.datajenisbantuan = Response.data.content.data;
                        this.datajenisbantuan.forEach((item) => {
                            this.jenisbantuan.push({
                                label: item.nama,
                                code: this.datajenisbantuan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.jenisbantuan.unshift({
                            label: 'Semua Bantuan Keuangan',
                            code: 0,
                            tag: '',
                        });
                    }
                    else {
                        this.datajenisbantuan = [];
                        this.jenisbantuan = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.datajenisbantuan = [];
                this.jenisbantuan = [];
                //console.log(error);
                this.halamanloading = false;
            });
            this.halamanloading = true;
            await mainAPI2.get("parastapainnovationreffbantuan-GetBidangBantuan?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.databidangbantuan = [];
                        this.bidangbantuan = [];
                        this.databidangbantuan = Response.data.content.data;
                        this.databidangbantuan.forEach((item) => {
                            this.bidangbantuan.push({
                                label: item.nama,
                                code: this.databidangbantuan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.bidangbantuan.unshift({
                            label: 'Semua Bidang Bantuan Keuangan',
                            code: 0,
                            tag: '',
                        });
                    }
                    else {
                        this.databidangbantuan = [];
                        this.bidangbantuan = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.databidangbantuan = [];
                this.bidangbantuan = [];
                //console.log(error);
                this.halamanloading = false;
            });

            this.halamanloading = true;
            await mainAPI2.get("parastapainnovationreffbantuan-GetSubBidangBantuan?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datasubbidangbantuan = [];
                        this.subbidangbantuan = [];
                        this.datasubbidangbantuan = Response.data.content.data;
                        this.datasubbidangbantuan.forEach((item) => {
                            this.subbidangbantuan.push({
                                label: item.nama,
                                code: this.datasubbidangbantuan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.subbidangbantuan.unshift({
                            label: 'Semua Sub Bidang Bantuan Keuangan',
                            code: 0,
                            tag: '',
                        });
                    }
                    else {
                        this.datasubbidangbantuan = [];
                        this.subbidangbantuan = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.datasubbidangbantuan = [];
                this.subbidangbantuan = [];
                //console.log(error);
                this.halamanloading = false;
            });
            this.halamanloading = true;
            await mainAPI2.get("parastapainnovationreff-GetJenisAnggaran?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.dataanggaran = [];
                        this.anggaran = [];
                        this.dataanggaran = Response.data.content.data;
                        this.dataanggaran.forEach((item) => {
                            this.anggaran.push({
                                label: item.nama,
                                code: this.dataanggaran.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.anggaran.unshift({
                            label: 'Semua Anggaran',
                            code: 0,
                            tag: '',
                        });
                    }
                    else {
                        this.dataanggaran = [];
                        this.anggaran = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.dataanggaran = [];
                this.anggaran = [];
                //console.log(error);
                this.halamanloading = false;
            });
        },
        async ambildatabidangterpilih() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });
            this.halamanloading = true;
            const mainAPI2 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                },
            });
            var random = Math.random();
            await mainAPI2.get("parastapainnovationreffbantuan-GetBidangBantuan?random=" + random + "&jenisbantuan=" + this.selectedjenisbantuan).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.databidangbantuan = [];
                        this.bidangbantuan = [];
                        this.databidangbantuan = Response.data.content.data;
                        this.databidangbantuan.forEach((item) => {
                            this.bidangbantuan.push({
                                label: item.nama,
                                code: this.databidangbantuan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.bidangbantuan.unshift({
                            label: 'Semua Bidang Bantuan Keuangan',
                            code: 0,
                            tag: '',
                        });
                    }
                    else {
                        this.databidangbantuan = [];
                        this.bidangbantuan = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.databidangbantuan = [];
                this.bidangbantuan = [];
                //console.log(error);
                this.halamanloading = false;
            });
        },
        async ambildatasubbidangterpilih() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });
            this.halamanloading = true;
            const mainAPI2 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                },
            });
            var random = Math.random();
            await mainAPI2.get("parastapainnovationreffbantuan-GetSubBidangBantuan?random=" + random + "&jenisbantuan=" + this.selectedjenisbantuan + "&bidangbantuan=" + this.selectedbidangbantuan).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datasubbidangbantuan = [];
                        this.subbidangbantuan = [];
                        this.datasubbidangbantuan = Response.data.content.data;
                        this.datasubbidangbantuan.forEach((item) => {
                            this.subbidangbantuan.push({
                                label: item.nama,
                                code: this.datasubbidangbantuan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.subbidangbantuan.unshift({
                            label: 'Semua Sub Bidang Bantuan Keuangan',
                            code: 0,
                            tag: '',
                        });
                    }
                    else {
                        this.datasubbidangbantuan = [];
                        this.subbidangbantuan = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.datasubbidangbantuan = [];
                this.subbidangbantuan = [];
                //console.log(error);
                this.halamanloading = false;
            });
        },
        async ambildata() {
            this.halamanloading = true;

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });

            const mainAPI2 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                },
            });
            var random = Math.random();
            await mainAPI2.get("parastapainnovationriwayat-ResumeRiwayat?random=" + random + "&tahun=" + this.selectedtahun
                + "&anggaran=" + this.selectedanggaran + "&kabkot=" + this.selectedkabkot + "&jenisbantuan=" + this.selectedjenisbantuan
                + "&bidangbantuan=" + this.selectedbidangbantuan + "&subbidangbantuan=" + this.selectedsubbidangbantuan
            ).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.totalkegiatan = 0;
                        this.totalalokasi = 0;
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.totalkegiatan = Response.data.content.totalkegiatan;
                        this.totalalokasi = Response.data.content.totalalokasi;
                    }
                    else {
                        this.datamaster = [];
                        this.totalkegiatan = 0;
                        this.totalalokasi = 0;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.datamaster = [];
                this.totalkegiatan = 0;
                this.totalalokasi = 0;
                //console.log(error);
                this.halamanloading = false;
            });

        },
        ontahunChange(a) {
            try {
                this.selectedtahun = this.tahun[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onanggaranChange(a) {
            try {
                this.selectedanggaran = this.anggaran[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onkabkotChange(a) {
            try {
                this.selectedkabkot = this.kabkot[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onjenisbantuanChange(a) {
            try {
                this.selectedjenisbantuan = this.jenisbantuan[a].tag;
            }
            catch (err) {
                return;
            }
            this.defaultSelectedbidangbantuan = {
                code: 0,
                label: 'Semua Bidang Bantuan Keuangan',
                tag: '',
            };
            this.selectedsubbidangbantuan = '';
            this.ambildatabidangterpilih();
            this.defaultSelectedsubbidangbantuan = {
                code: 0,
                label: 'Semua Sub Bidang Bantuan Keuangan',
                tag: '',
            };
            this.selectedsubbidangbantuan = '';
            this.ambildatasubbidangterpilih();

        },
        onbidangbantuanChange(a) {
            try {
                this.selectedbidangbantuan = this.bidangbantuan[a].tag;
            }
            catch (err) {
                return;
            }
            this.selectedsubbidangbantuan = '';
            this.defaultSelectedsubbidangbantuan = {
                code: 0,
                label: 'Semua Sub Bidang Bantuan Keuangan',
                tag: '',
            };
            this.selectedsubbidangbantuan = '';
            this.ambildatasubbidangterpilih();
        },
        onsubbidangbantuanChange(a) {
            try {
                this.selectedsubbidangbantuan = this.subbidangbantuan[a].tag;
            }
            catch (err) {
                return;
            }
        },
    },
    mounted() {
        this.ambildatareff();
        this.ambildata();
        this.cekdisklaimer();
        window.addEventListener('keydown', function (event) {
            if (event.code == 'KeyZ' && (event.ctrlKey || event.metaKey)) {
                localStorage.setItem("bookstamu", new Date().toString());
                $('#costumModaldisclaimer').modal('hide');
            }
        });
    },
}
</script>

<style></style>